import type { Dataset } from "@/api";

export function formatDatasetPageTitle(dataset: Dataset): string {
  return `Dataset: ${dataset.display_name}`;
}

// 데이터셋 계열 공용 문구(쓰기 거부 한국어화 포함)를 그대로 쓴다.
export { resolveErrorMessage } from "@/components/dataset/datasetFormatters";
